<div id="labs">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class=" inner-card">
                  <h4 class="card-title ">Mathematics</h4>
                  <div class="card-body text-justify">
                      <!-- <div class="row">
                        <div class="col-6 text-center mb-4">
                          <a href="/assets/img/campus/labs/3.jpeg" data-lightbox="Biology"><img src="/assets/img/campus/labs/3.jpeg" alt="Biology" class="img-fluid rounded"></a>
                          <h5 class="text-center mt-4">Biology</h5>
                          </div>
                      </div> -->
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>